import * as React from 'react';

const ConditionHeader: React.SFC<unknown> = () => (
    <div className="builder-header">
        <ul className="breadcrumbs">
            <li className="breadcrumb-item">
                <a href="#">Question builder</a>
            </li>
            <li className="breadcrumb-item">Conditions</li>
        </ul>
    </div>
);

export default ConditionHeader;
